import { Routes, Route, Navigate } from "react-router-dom";
import SubjectActivation from "./routes/SubjectActivation";
import SubjectSession from "./routes/SubjectSession";
import AdminSessionDetail from "./routes/AdminSessionDetail";
import PreviewInterview from "./routes/PreviewInterview";
import CeoSurvey from "./routes/CeoSurvey";
import AskTheRoom from "./routes/AskTheRoom";
import AdminSurvey from "./routes/AdminSurvey";
import { AccessGate } from "./components/survey/AccessGate";

export default function App() {
  return (
    <Routes>
      {/* The living survey is the front door now. */}
      <Route path="/" element={<Navigate to="/survey" replace />} />
      {/* Interviews admin hidden for now: /admin lands on the survey summary. */}
      <Route path="/admin" element={<Navigate to="/admin/survey" replace />} />
      <Route path="/admin/sessions/:id" element={<AdminSessionDetail />} />
      <Route path="/i/:code" element={<SubjectActivation />} />
      <Route path="/i/:code/session" element={<SubjectSession />} />
      <Route path="/preview/interview" element={<PreviewInterview />} />
      <Route path="/survey" element={<AccessGate><CeoSurvey /></AccessGate>} />
      <Route path="/ask" element={<AccessGate><AskTheRoom /></AccessGate>} />
      <Route path="/admin/survey" element={<AdminSurvey />} />
    </Routes>
  );
}
